import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { getClassProgramLive } from '@/api/classPrograms';

export const PROJECTOR_STEPS = [
  { label: 'Pick your sounds', threshold: 0 },
  { label: 'Build my beat', threshold: 1 },
  { label: 'Arrange your song', threshold: 3 },
  { label: 'Take it home', threshold: 5 },
];

export function projectorStep(seats = []) {
  const joined = seats.filter((seat) => seat.claimed);
  if (!joined.length) return 0;
  let active = 0;
  PROJECTOR_STEPS.slice(1).forEach((step, index) => {
    const past = joined.filter((seat) => Math.max(0, ...(seat.beats || []).map((beat) => Number(beat.summary?.furthest_step || 0))) >= step.threshold).length;
    if (past > joined.length / 2) active = index + 1;
  });
  return active;
}

export function ClassProgramProjector() {
  const { programId } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const load = useCallback(() => getClassProgramLive(programId).then((live) => { setData(live); setError(''); }).catch((requestError) => setError(requestError.message)), [programId]);
  useEffect(() => { load(); const timer = setInterval(load, 10000); return () => clearInterval(timer); }, [load]);
  const current = useMemo(() => projectorStep(data?.seats), [data]);
  const joined = data?.seats.filter((seat) => seat.claimed).length || 0;

  if (!data) return <main className="class-projector class-projector-loading" data-skin="playground"><p>{error || 'Loading class...'}</p></main>;
  return <main className="class-projector" data-skin="playground">
    <header><button onClick={() => navigate(`/facilitator/class/${programId}`)}>Live view</button><span>{joined} / {data.seats.length} joined</span><button onClick={() => navigate(`/facilitator/class/${programId}/showcase`)}>Showcase playlist</button></header>
    <section className="class-projector-code"><p>Go to</p><h1>arranger.letthebeatbuild.me/join</h1><strong>{data.program.class_code}</strong></section>
    <ol>{PROJECTOR_STEPS.map((step, index) => <li key={step.label} className={index === current ? 'current' : index < current ? 'done' : ''}><span>{index + 1}</span><b>{step.label}</b></li>)}</ol>
  </main>;
}

export default ClassProgramProjector;
